import fpApiUtil from "./fp-api-util";

const DEMAND = "factoryplan/master/order/demands";
const WORK_ORDER = "factoryplan/master/order/workorders";
// 고객/주문타입 조회는 order 도메인 전용 GET이 따로 없고, 여러 화면이 공유하는 공용 조회
// 엔드포인트(CommonController)를 그대로 쓴다(old도 동일 — factoryplan/customers, factoryplan/ordertypes).
const CUSTOMER_LOOKUP = "factoryplan/customers";
const CUSTOMER_CUD = "factoryplan/master/order/customers";
const ORDER_TYPE_LOOKUP = "factoryplan/ordertypes";
const ORDER_TYPE_CUD = "factoryplan/master/order/ordertypes";

const getDemands = (params) => fpApiUtil.postParams(DEMAND, params);
const upsertDemands = (changes) => fpApiUtil.postChanges(`${DEMAND}/save`, changes);
const removeDemands = (changes) => fpApiUtil.postChanges(`${DEMAND}/delete`, changes);

const getWorkOrders = (params) => fpApiUtil.postParams(WORK_ORDER, params);
const upsertWorkOrders = (changes) => fpApiUtil.postChanges(`${WORK_ORDER}/save`, changes);
const removeWorkOrders = (changes) => fpApiUtil.postChanges(`${WORK_ORDER}/delete`, changes);

const getCustomers = (params) => fpApiUtil.postParams(CUSTOMER_LOOKUP, params);
const saveCustomers = (changes) => fpApiUtil.postChanges(`${CUSTOMER_CUD}/save`, changes);
const removeCustomers = (changes) => fpApiUtil.postChanges(`${CUSTOMER_CUD}/delete`, changes);

const getOrderTypes = (params) => fpApiUtil.postParams(ORDER_TYPE_LOOKUP, params);
const saveOrderTypes = (changes) => fpApiUtil.postChanges(`${ORDER_TYPE_CUD}/save`, changes);
const removeOrderTypes = (changes) => fpApiUtil.postChanges(`${ORDER_TYPE_CUD}/delete`, changes);

const fpOrderService = {
  getDemands, upsertDemands, removeDemands,
  getWorkOrders, upsertWorkOrders, removeWorkOrders,
  getCustomers, saveCustomers, removeCustomers,
  getOrderTypes, saveOrderTypes, removeOrderTypes,
};
export default fpOrderService;
